'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemStyle = {
  padding: 10
};

var Pagination = function Pagination(props) {
  var onPageIncrement = props.onPageIncrement,
      onPageDecrement = props.onPageDecrement,
      currentPage = props.currentPage,
      totalPages = props.totalPages;

  return _react2.default.createElement(
    _semanticUiReact.Menu,
    { floated: 'right', pagination: true },
    _react2.default.createElement(
      _semanticUiReact.Menu.Item,
      { style: itemStyle, onClick: onPageDecrement, as: 'a', icon: true, disabled: currentPage <= 1 },
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'left chevron' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Menu.Item,
      { style: itemStyle, as: 'span' },
      currentPage,
      ' / ',
      totalPages
    ),
    _react2.default.createElement(
      _semanticUiReact.Menu.Item,
      { style: itemStyle, onClick: onPageIncrement, as: 'a', icon: true, disabled: currentPage === totalPages },
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'right chevron' })
    )
  );
};

Pagination.propTypes = {
  onPageIncrement: _propTypes2.default.func.isRequired,
  onPageDecrement: _propTypes2.default.func.isRequired,
  currentPage: _propTypes2.default.number.isRequired,
  totalPages: _propTypes2.default.number.isRequired
};

exports.default = Pagination;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/pagination/index.js
 ** module id = 239
 ** module chunks = 0
 **/